import { CloudDownload, Description, Link, PhoneIphone, Print, Visibility, FileCopy } from '@material-ui/icons';
import AddIcon from '@material-ui/icons/LibraryAdd';
import { calculateHeight } from 'common/services/util';
import { getColorState } from 'invoices/services/config';
import LiveMaterialTable from 'common/components/LiveMaterialTable';
import { Email } from '@material-ui/icons';
import React from 'react';
import TableTitle from 'common/components/TableTitle';

const TableInvoices = ({
    columns,
    data,
    onInvoiceAdd,
    onInvoiceUpdate,
    onInvoiceDelete,
    onInvoicePrint,
    onInvoicesExport,
    onConvertInInvoice,
    onSendInvoiceEmail,
    onDuplicateInvoice,
    isProforma,
    tableRefProp,
    getRowStyle,
    onSearchChange,
    onFilterChange,
}) => {
    return (
        <div className="zebra-table">
            <LiveMaterialTable
                title={<TableTitle>{isProforma ? 'Proformas' : 'Facturas'}</TableTitle>}
                tableRef={tableRefProp}
                icons={{
                    'Add': () => <AddIcon fontSize='large' color='primary'></AddIcon>
                }}
                actions={[
                    {
                        icon: () => <Visibility />,
                        tooltip: 'Visualizar',
                        onClick: (event, rowData) => onInvoicePrint(rowData, "view")
                    },
                    {
                        icon: () => <FileCopy />,
                        tooltip: 'Duplicar',
                        onClick: (event, rowData) => onDuplicateInvoice(rowData, "duplicate")
                    },
                    {
                        icon: () => <Print />,
                        tooltip: 'Imprimir',
                        onClick: (event, rowData) => onInvoicePrint(rowData, "print")
                    },
                    {
                        icon: () => <CloudDownload />,
                        tooltip: 'Descargar',
                        onClick: (event, rowData) => onInvoicePrint(rowData, "save")
                    },
                    {
                        icon: () => <PhoneIphone />,
                        tooltip: 'Enviar por Whatsapp',
                        onClick: (event, rowData) => onInvoicePrint(rowData, "upload")
                    },
                    {
                        icon: () => <Email />,
                        tooltip: 'Enviar por email',
                        onClick: async (event, rowData) => onSendInvoiceEmail(rowData)
                    },
                    {
                        icon: () => <Link />,
                        tooltip: 'Copiar link descarga',
                        onClick: (event, rowData) => onInvoicePrint(rowData, "clipboard")
                    },
                    isProforma && {
                        icon: () => <Description />,
                        tooltip: 'Convertir en factura',
                        onClick: (event, rowData) => onConvertInInvoice(rowData)
                    }
                ]}
                columns={columns}
                data={data}
                options={{
                    sorting: true,
                    filtering: true,
                    search: false,
                    actionsColumnIndex: 1,
                    toolbarButtonAlignment: 'left',
                    addRowPosition: 'first',
                    maxBodyHeight: calculateHeight(),
                    exportButton: true,
                    pageSize: 50,
                    pageSizeOptions: [5, 10, 25, 50, 100],
                    exportCsv: (columns, data) => {
                        onInvoicesExport(data)
                    },
                    rowStyle: (rowData, index) => (
                        getRowStyle ? getRowStyle(rowData, index)
                            : { backgroundColor: getColorState(rowData) }
                    )
                }}
                onFilterChange={() => onFilterChange && setTimeout(onFilterChange, 50)}
                onChangePage={() => onFilterChange && setTimeout(onFilterChange, 50)}
                onChangeRowsPerPage={() => onFilterChange && setTimeout(onFilterChange, 50)}
                onSearchChange={onSearchChange}
                editable={{
                    onRowAdd: onInvoiceAdd,
                    onRowUpdate: onInvoiceUpdate,
                    onRowDelete: onInvoiceDelete
                }}
            />
        </div>
    )
}

export default TableInvoices
